// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modern Sidebar Styling */
.sidebar-container {
    width: 250px;
    height: 100vh;
    position: fixed;
    background: #458acf;
    display: flex;
    flex-direction: column;
    color: #ecf0f1;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
  }
  
  .sidebar-logo {
    padding: 20px;
    text-align: center;
    font-size: 1.5rem;
    font-weight: bold;
    color: #ecf0f1;
    border-bottom: 1px solid #56799c;
    transition: color 0.3s ease;
  }
  
  .sidebar-logo:hover {
    color: #00bcd4;
  }
  
  .sidebar-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .sidebar-menu li {
    margin: 20px 0;
    transition: all 0.3s ease;
  }
  
  .sidebar-link {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    text-decoration: none;
    color: inherit;
    transition: background 0.3s ease, color 0.3s ease;
  }
  
  .sidebar-link:hover {
    background: #34495e;
    color: #00bcd4;
  }
  
  .sidebar-icon {
    font-size: 1.5rem;
    margin-right: 15px;
  }
  
  .link-text {
    font-size: 1.1rem;
    font-weight: 500;
    transition: transform 0.3s ease;
  }
  
  .sidebar-link:hover .link-text {
    transform: translateX(5px);
  }
  
  @media (max-width: 768px) {
    .sidebar-container {
      width: 200px;
    }
    .sidebar-logo {
      font-size: 1.2rem;
    }
    .link-text {
      font-size: 1rem;
    }
  }
  
  @media (max-width: 576px) {
    .sidebar-container {
      width: 180px;
    }
    .sidebar-link {
      padding: 10px 15px;
    }
    .sidebar-logo {
      padding: 15px;
    }
    .link-text {
      font-size: 0.9rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/dashboard/styles/sidebar.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,YAAY;IACZ,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,wCAAwC;IACxC,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,gCAAgC;IAChC,2BAA2B;EAC7B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,iDAAiD;EACnD;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE;MACE,YAAY;IACd;IACA;MACE,iBAAiB;IACnB;IACA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,YAAY;IACd;IACA;MACE,kBAAkB;IACpB;IACA;MACE,aAAa;IACf;IACA;MACE,iBAAiB;IACnB;EACF","sourcesContent":["/* Modern Sidebar Styling */\n.sidebar-container {\n    width: 250px;\n    height: 100vh;\n    position: fixed;\n    background: #458acf;\n    display: flex;\n    flex-direction: column;\n    color: #ecf0f1;\n    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n    transition: all 0.3s ease-in-out;\n  }\n  \n  .sidebar-logo {\n    padding: 20px;\n    text-align: center;\n    font-size: 1.5rem;\n    font-weight: bold;\n    color: #ecf0f1;\n    border-bottom: 1px solid #56799c;\n    transition: color 0.3s ease;\n  }\n  \n  .sidebar-logo:hover {\n    color: #00bcd4;\n  }\n  \n  .sidebar-menu ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .sidebar-menu li {\n    margin: 20px 0;\n    transition: all 0.3s ease;\n  }\n  \n  .sidebar-link {\n    display: flex;\n    align-items: center;\n    padding: 15px 20px;\n    text-decoration: none;\n    color: inherit;\n    transition: background 0.3s ease, color 0.3s ease;\n  }\n  \n  .sidebar-link:hover {\n    background: #34495e;\n    color: #00bcd4;\n  }\n  \n  .sidebar-icon {\n    font-size: 1.5rem;\n    margin-right: 15px;\n  }\n  \n  .link-text {\n    font-size: 1.1rem;\n    font-weight: 500;\n    transition: transform 0.3s ease;\n  }\n  \n  .sidebar-link:hover .link-text {\n    transform: translateX(5px);\n  }\n  \n  @media (max-width: 768px) {\n    .sidebar-container {\n      width: 200px;\n    }\n    .sidebar-logo {\n      font-size: 1.2rem;\n    }\n    .link-text {\n      font-size: 1rem;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .sidebar-container {\n      width: 180px;\n    }\n    .sidebar-link {\n      padding: 10px 15px;\n    }\n    .sidebar-logo {\n      padding: 15px;\n    }\n    .link-text {\n      font-size: 0.9rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
